import React, {useEffect} from 'react';
import css from './Notifications.module.scss'
import close from "../../../images/close.svg";
import {SHARE, SUBMIT_EDIT} from "../../../redux/types";
import Notification from "./Notification";
import {useTheme} from "../../../App";
import {useTranslation} from "react-i18next";
import {connect} from "react-redux";
import {getNotifications} from "../../../redux/notifications/notifications-thunks";

const Notifications = ({closeModal, ...props}) => {
  const {isDark} = useTheme()
  const {t} = useTranslation()

  return (
    <div className={`${css.notifications} notifications ${isDark && 'notifications__dark'}`}>
      <button onClick={closeModal} className="modal__close">
        <img src={close} alt=""/>
      </button>
      <h5 className="modal__title mr-30">{t('New notifications')}: {props.notifications.filter(n => n.is_delivered === false).length}</h5>
      {props.notifications.map((notif, index) => <Notification notification={notif} key={index} />)}
    </div>
  );
};

const mapStateToProps = (state) => ({
  notifications: state.notificationsReducer.notifications,
  user: state.userReducer.user
})

export default connect(mapStateToProps, {getNotifications})(React.memo(Notifications))
